// extracted by mini-css-extract-plugin
export default {"bLoans":"FAQPage_bLoans__P6faj","dFinance":"FAQPage_dFinance__e7WmC","sRepo":"FAQPage_sRepo__4E2Yu","reBridging":"FAQPage_reBridging__Z5SRr"};